import React from 'react';
import { FlaskConicalIcon } from 'lucide-react';
interface PrototypeNoteProps {
  children: React.ReactNode;
  /** 'chip' for inline lists, 'block' for a full-width line under a heading. */
  variant?: 'chip' | 'block';
  className?: string;
}

/**
 * Reviewer scaffolding. Deliberately unlike anything in the product — dashed,
 * monospaced, uncoloured — so nobody mistakes it for a member-facing badge.
 */
export function PrototypeNote({
  children,
  variant = 'chip',
  className = ''
}: PrototypeNoteProps) {
  const base = 'inline-flex items-start gap-1.5 rounded-field border border-dashed border-rule text-ink-muted';
  const size = variant === 'chip' ? 'px-2 py-0.5 font-mono text-eyebrow-caption uppercase tracking-[0.1em]' : 'w-full px-3 py-2 text-small';
  return <span className={`${base} ${size} ${className}`} data-id="element-364" data-mp="2ta4xtk7o7fmw">
      <FlaskConicalIcon aria-hidden="true" className="mt-0.5 h-3 w-3 shrink-0" data-id="element-365" data-mp="2tamyct1d8g0m" />
      <span data-id="element-366" data-mp="2xa5nk107zd99">
        <span className="sr-only" data-id="element-367" data-mp="2xanp9d5nijok">Prototype note: </span>
        {children}
      </span>
    </span>;
}